export default __webpack_public_path__ + "static/164-9d686f6221d47617bf4e6401b182ac0e.jpg";